<template>
  <v-layout wrap fill-height>
    <headband />
    
    <div
      class="w-100"
      v-if="blocks.legnth !== 0"
    >
      <keep-alive>
        <block-videos :items="getBlocksVideo()" />
      </keep-alive>
      <keep-alive>
        <block-new-product :items="getBlocksPromote()" />
      </keep-alive>
      <keep-alive>
        <block-corporate-documents :items="getBlocksCorporate()" />
      </keep-alive>
      <keep-alive>
        <block-markets />
      </keep-alive>
    </div>
    <block-newsletter v-if="blocks.legnth !== 0" />
  </v-layout>
</template>
<script>
import Mixins from '@/core/mixins'
export default {
  name: 'home',
  mixins: [ Mixins ],
  data() {
    return {
      blocks: []
    }
  },

  components: {
    Headband: () => import(/* webpackChunkName: "Headband" */ '@/modules/headband/Headband'),
    BlockNewsletter: () => import(/* webpackChunkName: "BlockNewsletter" */ '@/modules/block/BlockNewsletter'),
    BlockCorporateDocuments: () => import(/* webpackChunkName: "BlockCorporateDocuments" */ '@/modules/block/BlockCorporateDocuments'),
    BlockNewProduct: () => import(/* webpackChunkName: "BlockNewProduct" */ '@/modules/block/BlockNewProduct'),
    BlockVideos: () => import(/* webpackChunkName: "BlockVideos" */ '@/modules/block/BlockVideos'),
    BlockMarkets: () => import(/* webpackChunkName: "BlockMarkets" */ '@/modules/block/BlockMarkets'),
  },

  mounted() {
    this.$ga.page('/');
  },

  created () {
    this.handler()
  },

  methods: {
    async handler () {
      const response = await this.request(`/settings/blocks`)
      this.blocks = response
    },

    getBlocksVideo () {
      const codeLang = this.$i18n.locale.split('-')[0]
      return this.blocks.filter(f => f.regions.includes('videoMaintenace') && f.language === codeLang)
    },

    getBlocksPromote () {
      const codeLang = this.$i18n.locale.split('-')[0]
      return this.blocks.filter(f => f.regions.includes('promoteProduct') && f.language === codeLang)
    },
    
    getBlocksCorporate () {
      const codeLang = this.$i18n.locale.split('-')[0]
      return this.blocks.filter(f => f.regions.includes('corporateProduct') && f.language === codeLang)
    }
  }
}
</script>
<style>
.v-img__image-container:after {
  content: "";
  background: rgba(0, 92, 170, 0.1);
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
}
</style>
